<template>
  <div>
    <div>
      <el-select
        id="oxygen-routes-select"
        v-close-on-zoom
        :value="state.selectedOxygens"
        placeholder="Routes"
        :filterable="true"
        :multiple="true"
        class="oxygen-routes-select"
        :disabled="readonly"
        @input="oxygenKeys => selectOxygens(oxygenKeys)"
      >
        <el-option
          v-for="oxygen in availableOxygens"
          :key="oxygen.id"
          :label="oxygen.name.en"
          :value="oxygen.id"
        />
      </el-select>
      <help-tooltip v-if="warnings && warnings.length" type="warning">
        <span v-for="warning in warnings" :key="warning.message">
          {{ warning.message }}
          <br>
        </span>
      </help-tooltip>
    </div>
  </div>
</template>

<script>
import { get, keyBy, uniqBy } from 'lodash';

import HelpTooltip from '~lib/common/components/HelpTooltip';

export default {
  name: 'oxygen-action',
  components: {
    HelpTooltip,
  },
  props: [
    'oxygens',
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      state: {
        selectedOxygens: [],
      },
    };
  },
  computed: {
    oxygensMap() {
      return keyBy(this.oxygens, 'id');
    },
    availableOxygens() {
      return this.emitter.caseConf._oxygens.filter(x => get(x, 'options.enabled'))
        .map(x => this.oxygensMap[x.id]);
    },
    warnings() {
      if (!this.emitter.$store) {
        return [];
      }
      return uniqBy(
        get(
          this.emitter.$store.getters['validation/visibleWarningsByFieldAndId'],
          `caseLogicDescription.${this.control.parent.id}`,
        ),
        'message',
      ).filter(warning => warning.metadata && warning.metadata.scope === 'control');
    },
  },
  created() {},
  mounted() {
    const data = this.getData(this.ikey);
    this.state.selectedOxygens = get(data, 'routes') || [];
    this.update();
  },
  methods: {
    selectOxygens(oxygenKeys) {
      this.state.selectedOxygens = oxygenKeys;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'OXYGEN',
        id: 'OXYGEN',
        routes: this.state.selectedOxygens,
      });
      this.emitter.trigger('process', this.control);
    },
  },
};
</script>

<style scoped>
</style>
